// Helper funkcija za proveru da li je demo mode aktivan
export const isDemoMode = () => {
  if (typeof window === 'undefined') return false;
  return window.location.pathname.startsWith('/demo') || 
         localStorage.getItem('demoMode') === 'true';
};

// Helper funkcija za postavljanje demo mode-a
export const setDemoMode = (enabled, role = null) => {
  if (enabled) {
    localStorage.setItem('demoMode', 'true');
    if (role) {
      localStorage.setItem('demoRole', role);
    }
  } else {
    localStorage.removeItem('demoMode');
    localStorage.removeItem('demoRole');
  }
};

// Helper funkcija za dobijanje demo role-a
export const getDemoRole = () => {
  return localStorage.getItem('demoRole') || 'customer';
};

// Helper funkcija za proveru da li je demo role
export const isDemoRole = (role) => {
  return getDemoRole() === role;
};
